module.exports = __webpack_public_path__ + "static/media/coffee_icon.352f327a.png";